// @flow

import styled from 'styled-components';

import { FORM_ROW_HEIGHT } from '../../../constants';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: ${props => props.rowHeight || FORM_ROW_HEIGHT};
  padding: 16px ${props => (props.noPaddingHorizontal ? 0 : '16px')};
  border-top-width: ${props => (props.borderTop ? '1px' : '0px')};
  border-top-color: ${props => props.theme[props.themeColor] || props.theme.separatorColor};
  border-top-style: solid;
  border-bottom-width: ${props => (props.borderBottom ? '1px' : '0px')};
  border-bottom-color: ${props => props.theme[props.themeColor] || props.theme.separatorColor};
  border-bottom-style: solid;
`;

export default Row;
